import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const setGeneralCookie = (key: string, value: string, maxAgeSecond: number) => {
    const isProd = process.env.NODE_ENV === 'production';
    cookies.set(key, value,
        {
            maxAge: maxAgeSecond, //refresh token keep for a week
            domain: isProd ? window.location.hostname : 'localhost',
            secure: isProd ? true : undefined,
            sameSite: isProd ? 'lax' : undefined,
            path: '/'
        });
}